import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { IApplicationContext } from 'shared/common/types/applicationContext';
import { TReduxStore } from 'shared/common/types/redux';
import { ApplicationContext } from 'shared/common/utils/applicationContext';
import { BuyerPageContainer } from 'shared/landingBuyer/containers/BuyerPage';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const LandingBuyerApp: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <BuyerPageContainer />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
